export const varietyFilters = [
  { value: 0, text: 'Split', color: 'blue' },
  { value: 1, text: 'Package', color: 'blue' },
  { value: 2, text: 'Mini-Split', color: 'blue' },
  // { value: 3, text: 'Mobile Home', color: 'blue' },
  { value: 4, text: 'A la carte', color: 'blue' },
];
